"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoiCalculatorCard = void 0;
var react_1 = __importDefault(require("react"));
var SimpleTimelineCard_1 = require("./SimpleTimelineCard");
var RoiCalculatorCard = function (_a) {
    var interactionEventData = _a.interactionEventData, headingButton = _a.headingButton;
    return (react_1.default.createElement(SimpleTimelineCard_1.SimpleTimelineCard, { heading: "ROI Calculator Updated", headingButton: headingButton, details: getDetails(interactionEventData) }));
};
exports.RoiCalculatorCard = RoiCalculatorCard;
function getDetails(eventData) {
    var e_1, _a;
    var details = [];
    if (eventData.roiCalculatorLabel) {
        details.push({ title: "ROI calculator title", value: eventData.roiCalculatorLabel });
    }
    if (eventData.sliderValue)
        details.push({ title: "Slider value", value: eventData.sliderValue });
    if (eventData.variables) {
        try {
            for (var _b = __values(eventData.variables), _c = _b.next(); !_c.done; _c = _b.next()) {
                var variable = _c.value;
                details.push({ title: "".concat(variable.term), value: variable.termValue });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return details;
}
